import React, { useState } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import {
  Text,
  Box,
  MenuPopover,
  Button
} from '.'
import {
  ListItem as MuiListItem,
  ListItemText as MuiListItemText,
  ListItemIcon as MuiListItemIcon,
  useTheme,
} from '@material-ui/core'
import useStyles from './styles'
import { Draggable } from "react-beautiful-dnd"

const MyLink = (props) => {
  // This will create black text on list item, but it will stay black
  // when selected. So I'll use this component only when not selected.
  return <Link {...props} style={{ color: 'inherit', textDecoration: 'none' }} />

  // Don't know why this crash. This should be the best solution.
  const classes = useStyles()
  return
  <Link className={classes.link} {...props} />
}

export const ListItem = ({
  icon, primary, secondary, label, linkTo, selected, onClick, menuPopupValue, noGutter = false, noGutterY = false, iconSize = 'small', labelTypographyProps = {},
  variant = 'button', draggableId, index, rightIcon, ...props
}) => {
  const primaryTypographyProps = { variant: "body2", ...(props.primaryTypographyProps || {})}
  const secondaryTypographyProps = props.secondaryTypographyProps || {}

  const [openMenu, setOpenMenu] = useState(false)
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null)
  const toggleMenu = (target, open) => {
    setPopoverAnchorEl(target)
    setOpenMenu(open)
  }

  const classes = useStyles()
  const theme = useTheme()
  let iconStyle = {}
  if (selected)
    iconStyle["color"] = theme.palette.primary.main
  else
    iconStyle["color"] = "#444"

  let listItem

  if (variant == 'link')
    listItem = (
      <MuiListItem
        className={clsx(classes.listItem, classes.listItemLink, selected && classes.listItemLinkSelected, onClick && classes.pointer)}
        component={selected ? Link : MyLink}
        to={linkTo}
        onClick={onClick}
      >
        {icon &&
          <Box className={classes.listItemIcon}>
            {React.createElement(icon, { fontSize: iconSize, style: iconStyle })}
          </Box>
        }
        <Box className={classes.listItemText}>
          <Text variant="body1">{primary}</Text>
          {secondary &&
            <Text variant="body2">{secondary}</Text>
          }
        </Box>
      </MuiListItem>
    )
  else if (variant == 'menuitem')
    listItem = (
      <MuiListItem
        className={clsx(classes.listItem, classes.listItemMenu, selected && classes.listItemLinkSelected, onClick && classes.pointer)}
        component={selected ? Link : MyLink}
        to={linkTo}
        onClick={onClick}
      >
        {icon &&
          <div className={classes.listItemIcon}>
            {React.createElement(icon, { fontSize: iconSize, style: iconStyle })}
          </div>
        }
        <div className={classes.listItemMenuPrimary}>
          <Text variant="body2">{primary}</Text>
        </div>
        {secondary &&
          <div className={classes.listItemMenuSecondary}>
            <Text variant="body2" color="textMuted">{secondary}</Text>
          </div>
        }
      </MuiListItem>
    )
  else if (variant === "card")
    listItem = (
      <MuiListItem
        className={clsx(classes.listItem, classes.listItemButton, selected && classes.listItemButtonSelected, onClick && classes.pointer)}
        component={selected ? Link : MyLink}
        to={linkTo}
        onClick={(e) => {
          if(onClick){
            e.preventDefault()
            e.stopPropagation()
            onClick()
          }
        }}
        classes={{ root: classes.card }}
      >
        {icon &&
          <Box className={classes.listItemIcon}>
            {React.createElement(icon, { fontSize: iconSize, style: iconStyle })}
          </Box>
        }
        <MuiListItemText primary={primary} secondary={secondary} primaryTypographyProps={primaryTypographyProps} />
        {
          rightIcon ? 
            <MuiListItemIcon style={{justifyContent: 'flex-end', alignItems: 'center'}}>
              {
                Array.isArray(rightIcon) ? 
                rightIcon.map(item => item) :
                rightIcon
              }
            </MuiListItemIcon> :
            <></>
        }
      </MuiListItem>
    )
  else
    listItem = (
      <MuiListItem
        className={clsx(classes.listItem, classes.listItemButton, selected && classes.listItemButtonSelected, noGutter && classes.listItemNoMargin, noGutterY && classes.listItemNoMarginY, onClick && classes.pointer)}
        component={selected ? Link : MyLink}
        to={linkTo}
        onClick={onClick}
        {...props}
      >
        {icon &&
          <Box className={classes.listItemIcon}>
            {React.createElement(icon, { fontSize: iconSize, style: iconStyle })}
          </Box>
        }
        {!icon && Boolean(props.leftItemRender) && (
          <Box className={classes.listItemAvatar} style={{ flexShrink: 0 }}>
            {props.leftItemRender()}
          </Box>
        )}
        <Box
          // width="100%"
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          flex="1 1 0%"
          minWidth={0}
        >
          {label &&
            <Box 
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Text variant="body2" color="textMuted" {...labelTypographyProps}>{label}</Text>
              <Box display="flex">
                {props?.titleButtons && props?.titleButtons?.map(button => (
                  <Button {...button}
                    onClick={(event) => { event.stopPropagation(); button.onClick(); }}
                  />
                ))}
              </Box>
            </Box>
          }
          <MuiListItemText
            primary={primary}
            secondary={secondary}
            primaryTypographyProps={primaryTypographyProps}
            secondaryTypographyProps
            onClick={(e) => {
              menuPopupValue && toggleMenu(e.target, true)
            }}
            className={clsx((menuPopupValue && menuPopupValue.length > 0) && classes.pointer)}
          />
          {
            menuPopupValue && menuPopupValue.length > 0 && (
              <MenuPopover
                open={openMenu && Boolean(popoverAnchorEl)}
                onClose={(e) => {
                  toggleMenu(null, false)
                }}
                keepMounted
                anchorEl={popoverAnchorEl}
                menuItems={menuPopupValue}
                // classes={{
                //   list: classes.itemSelectMenu
                // }}
              />
            )
          }
        </Box>
        {
          rightIcon ? 
            <MuiListItemIcon style={{ justifyContent: 'flex-end', alignItems: 'center', flexShrink: 0 }}>
              {
                Array.isArray(rightIcon) ? 
                rightIcon.map(item => item) :
                rightIcon
              }
            </MuiListItemIcon> :
            <></>
        }
      </MuiListItem>
    )

  if (draggableId) {
    return (
      <Draggable draggableId={draggableId} index={index}>
        {provided => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            tabIndex={null}
          >
            {listItem}
          </div>
        )}
      </Draggable>
    )
  }
  else
    return listItem
}

export default ListItem